import { TextField as MuiTextField } from "@mui/material";

import { getFieldErrorMessage, useFieldContext, useShowFieldError } from "./form.context";

type Props = {
  label?: string;
  placeholder?: string;
  type?: string;
  disabled?: boolean;
  legend?: boolean;
  multiline?: boolean;
  rows?: number;
};

export function TextField({
  label,
  placeholder,
  type = "text",
  disabled,
  legend = true,
  multiline,
  rows,
}: Props) {
  const field = useFieldContext<string | undefined>();
  const errors = field.state.meta.errors;
  const hasError = useShowFieldError(errors);
  const errorMessage = getFieldErrorMessage(errors);
  const hasLabel = Boolean(label);

  const displayValue = field.state.value ?? "";

  return (
    <MuiTextField
      name={field.name}
      label={hasLabel ? label : undefined}
      variant="standard"
      type={type}
      fullWidth
      size="small"
      disabled={disabled}
      multiline={multiline}
      rows={rows}
      value={displayValue}
      onChange={(e) => field.handleChange(e.target.value)}
      onBlur={field.handleBlur}
      error={hasError}
      helperText={hasError ? errorMessage : undefined}
      placeholder={placeholder}
      slotProps={undefined}
      sx={(theme) => ({
        "& .MuiInputLabel-root": { color: theme.palette.text.secondary },
        "& .MuiInputLabel-root.Mui-focused": { color: theme.palette.primary.main },
        "& .MuiFormHelperText-root": {
          marginLeft: 0,
        },
        ...(!legend && {
          "& fieldset": {
            top: 0,
            "& legend": {
              display: "none",
            },
          },
        }),
      })}
    />
  );
}
